<template>
  <div>
    <b-container fluid class="p-0">
      <main>
        <!-- NOTE: 見出し -->
        <CommonTitle :titleProps="'承認'" class="fs-24-bold"/>
        <!-- コンテンツ領域 -->
        <b-card>
        <validation-observer ref="searchValidationObserver" v-slot="{ handleSubmit }">
          <b-form-group class="p-0 m-0" size="lg">
            <b-form @submit.stop.prevent="onSearchButtonClick" novalidate>
              <b-collapse id="open-form" v-model="visible" class="mb-3">
                <b-row class="p-0 m-0">
                  <b-col cols="3" class="w-100 pr-1 pl-0">
                    <label class="mb-1">TAS ID</label>
                    <validation-provider name="TAS ID" :rules="{ max: 100, hankakuNumber: true }" v-slot="validationContext">
                      <b-form-group class="m-0">
                        <b-form-input
                            v-model="inputSearchTasId"
                            type="search"
                            :state="getValidationState(validationContext)"
                            aria-describedby="input-tasId-live-feedback"
                        />
                        <b-form-invalid-feedback id="input-tasId-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="3" class="w-100 pb-1 px-1">
                    <label class="mb-1">申込番号</label>
                    <validation-provider name="申込番号" :rules="{ max: 100 }" v-slot="validationContext">
                      <b-form-group class="m-0">
                        <b-form-input
                            v-model="inputSearchCustomerId"
                            type="search"
                            :state="getValidationState(validationContext)"
                            aria-describedby="input-customerId-live-feedback"
                        />
                        <b-form-invalid-feedback id="input-customerId-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="3" class="w-100 pb-1 px-1">
                    <label class="mb-1">会社名</label>
                    <validation-provider name="会社名" :rules="{ max: 100 }" v-slot="validationContext">
                      <b-form-group class="m-0">
                        <b-form-input
                            v-model="inputSearchForAnswerCorporateName"
                            type="search"
                            :state="getValidationState(validationContext)"
                            aria-describedby="input-corporateName-live-feedback"
                        />
                        <b-form-invalid-feedback id="input-corporateName-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="3" class="w-100 pr-0 pl-1 pb-1">
                    <label class="mb-1">担当者名</label>
                    <validation-provider name="担当者名" :rules="{ max: 100 }" v-slot="validationContext">
                      <b-form-group class="m-0">
                        <b-form-input
                            v-model="inputSearchPersonInChargeName"
                            type="search"
                            :state="getValidationState(validationContext)"
                            aria-describedby="input-personInChargeName-live-feedback"
                        />
                        <b-form-invalid-feedback id="input-personInChargeName-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="3" class="w-100 pr-1 pl-0 mt-2">
                    <label class="mb-1">メールアドレス</label>
                    <validation-provider name="メールアドレス" :rules="{ max: 100 }" v-slot="validationContext">
                      <b-form-group class="m-0">
                        <b-form-input
                            v-model="inputSearchMailAddress"
                            type="search"
                            :state="getValidationState(validationContext)"
                            aria-describedby="input-mailAddress-live-feedback"
                        />
                        <b-form-invalid-feedback id="input-mailAddress-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="3" class="w-100 px-1 mt-2">
                    <label class="mb-1">電話番号</label>
                    <validation-provider name="電話番号" :rules="{ max: 100 }" v-slot="validationContext">
                      <b-form-group class="m-0">
                        <b-form-input
                            v-model="inputSearchTelephoneNumber"
                            type="search"
                            :state="getValidationState(validationContext)"
                            aria-describedby="input-telephoneNumber-live-feedback"
                        />
                        <b-form-invalid-feedback id="input-telephoneNumber-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="3" class="w-100 px-1 mt-2">
                    <label class="mb-1">携帯電話番号</label>
                    <validation-provider name="携帯電話番号" :rules="{ max: 100 }" v-slot="validationContext">
                      <b-form-group class="m-0">
                        <b-form-input
                            v-model="inputSearchMobileTelephoneNumber"
                            type="search"
                            :state="getValidationState(validationContext)"
                            aria-describedby="input-mobileTelephoneNumber-live-feedback"
                        />
                        <b-form-invalid-feedback id="input-mobileTelephoneNumber-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="3" class="w-100 mt-2 pl-1 pr-0">
                    <label class="mb-1">申し込み日時</label>
                    <validation-observer vid="input-search-registered-timestamp-approval" v-slot="validationContext">
                      <div class="box-input-ranger">
                        <div class="content-input">
                          <div class="input-date input-date-start">
                            <validation-provider
                              class="m-0"
                              name="申し込み日時の開始日"
                              :rules="{
                                                  validityStateCheck: $refs['input-search-registered-timestamp-from'] ? {
                                                    target: $refs['input-search-registered-timestamp-from']
                                                  } : false,
                                                  dateCheck: true
                                                }"
                              ref="inputSearchRegisteredTimestampFrom"
                              v-slot="validationContext"
                          >
                            <b-form-input
                                type="date"
                                max="9999-12-31"
                                v-model="inputSearchRegisteredTimestampFrom"
                                :state="getValidationState(validationContext)"
                                aria-describedby="input-dateFromTo1-live-feedback-from"
                                ref="input-search-registered-timestamp-from"
                            />
                            <b-form-invalid-feedback
                                id="input-dateFromTo1-live-feedback-from"
                            >
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </validation-provider>
                          </div>
                          <div class="icon-space">
                            <div class="align-middle">〜</div>
                          </div>
                          <div class="input-date input-date-end">
                            <validation-provider
                              class="m-0"
                              name="申し込み日時の終了日"
                              :rules="{
                                                  validityStateCheck: $refs['input-search-registered-timestamp-to'] ? {
                                                    target: $refs['input-search-registered-timestamp-to']
                                                  } : false,
                                                  dateCheck: true,
                                                  dateDiffCheckOrSameMonthWithDateMessage: {
                                                    start: inputSearchRegisteredTimestampFrom,
                                                    end: inputSearchRegisteredTimestampTo
                                                  }
                                                }"
                              ref="inputSearchRegisteredTimestampTo"
                              v-slot="validationContext"
                          >
                            <b-form-input
                                type="date"
                                max="9999-12-31"
                                v-model="inputSearchRegisteredTimestampTo"
                                :state="getValidationState(validationContext)"
                                aria-describedby="input-dateFromTo1-live-feedback-to"
                                ref="input-search-registered-timestamp-to"
                            />
                            <b-form-invalid-feedback
                                id="input-dateFromTo1-live-feedback-to"
                            >
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </validation-provider>
                          </div>
                        </div>
                        <div class="icon-clear" @click="inputSearchRegisteredTimestampClear" >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                            <g id="Group_1089" data-name="Group 1089" transform="translate(-1046 -235)">
                              <rect id="Rectangle_370" data-name="Rectangle 370" width="16" height="16" rx="8" transform="translate(1046 235)" fill="#eceff2"/>
                            </g>
                            <g id="Group_1091" data-name="Group 1091" transform="translate(-500 -440)">
                              <line id="Line_176" data-name="Line 176" x2="8" transform="translate(505.172 445.171) rotate(45)" fill="none" stroke="#3c3c3c" stroke-linecap="round" stroke-width="1"/>
                              <g id="Group_1090" data-name="Group 1090" transform="translate(465.574 -228.701) rotate(45)">
                                <line id="Line_177" data-name="Line 177" x2="8" transform="translate(508.5 444.5) rotate(90)" fill="none" stroke="#3c3c3c" stroke-linecap="round" stroke-width="1"/>
                              </g>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </validation-observer>
                  </b-col>
                  <b-col cols="3" class="w-100 pt-1 pr-1 pl-0 mt-2 pb-0">
                    <label class="mb-1">サービス開始日</label>
                    <validation-observer vid="service_start_year_month" v-slot="validationContext">
                      <div class="box-input-ranger">
                        <div class="content-input">
                          <div class="input-date input-date-start">
                            <validation-provider
                                class="m-0"
                                name="サービス開始日の開始日"
                                :rules="{
                            validityStateCheck: $refs['input-search-service-start-date-from'] ? {
                              target: $refs['input-search-service-start-date-from']
                            } : false,
                            dateCheck: true
                          }"
                                ref="inputSearchServiceStartDateFrom"
                                v-slot="validationContext"
                            >
                              <b-form-input
                                  type="date"
                                  max="9999-12-31"
                                  v-model="inputSearchServiceStartDateFrom"
                                  :state="getValidationState(validationContext)"
                                  aria-describedby="input-dateFromTo1-live-feedback-from"
                                  ref="input-search-service-start-date-from"
                              />
                              <b-form-invalid-feedback
                                  id="input-dateFromTo2-live-feedback-from"
                              >
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </validation-provider>
                          </div>
                          <div class="icon-space">
                            <div class="align-middle">〜</div>
                          </div>
                          <div class="input-date input-date-end">
                            <validation-provider
                                class="m-0"
                                name="サービス開始日の終了日"
                                :rules="{
                            validityStateCheck: $refs['input-search-service-start-date-to'] ? {
                              target: $refs['input-search-service-start-date-to']
                            } : false,
                            dateCheck: true,
                            dateDiffCheckOrSameMonthWithDateMessage: {
                              start: inputSearchServiceStartDateFrom,
                              end: inputSearchServiceStartDateTo
                            }
                          }"
                                ref="inputSearchServiceStartDateTo"
                                v-slot="validationContext"
                            >
                              <b-form-input
                                  type="date"
                                  max="9999-12-31"
                                  v-model="inputSearchServiceStartDateTo"
                                  :state="getValidationState(validationContext)"
                                  aria-describedby="input-dateFromTo2-live-feedback-to"
                                  ref="input-search-service-start-date-to"
                              />
                              <b-form-invalid-feedback
                                  id="input-dateFromTo2-live-feedback-to"
                              >
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </validation-provider>
                          </div>
                        </div>
                        <div class="icon-clear" @click="inputSearchServiceStartDateClear" >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                            <g id="Group_1089" data-name="Group 1089" transform="translate(-1046 -235)">
                              <rect id="Rectangle_370" data-name="Rectangle 370" width="16" height="16" rx="8" transform="translate(1046 235)" fill="#eceff2"/>
                            </g>
                            <g id="Group_1091" data-name="Group 1091" transform="translate(-500 -440)">
                              <line id="Line_176" data-name="Line 176" x2="8" transform="translate(505.172 445.171) rotate(45)" fill="none" stroke="#3c3c3c" stroke-linecap="round" stroke-width="1"/>
                              <g id="Group_1090" data-name="Group 1090" transform="translate(465.574 -228.701) rotate(45)">
                                <line id="Line_177" data-name="Line 177" x2="8" transform="translate(508.5 444.5) rotate(90)" fill="none" stroke="#3c3c3c" stroke-linecap="round" stroke-width="1"/>
                              </g>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </validation-observer>
                  </b-col>
                  <b-col cols="3" class="w-100 pt-1 px-1 mt-2 pb-0">
                    <label class="mb-1">承認カテゴリ</label>
                    <b-form-select
                        id="status"
                        v-model="inputSearchApprovalCategory"
                    >
                      <option value="">未選択</option>
                      <option value="1">内容承認</option>
                      <option value="2">書類承認</option>
                      <option value="3">変更承認</option>
                    </b-form-select>
                  </b-col>
                  <b-col cols="3" class="w-100 pt-1 px-1 mt-2 pb-0">
                    <label class="mb-1">承認</label>
                    <b-form-select
                        id="status"
                        v-model="inputSearchApprovalRequestStatus"
                    >
                      <option value="">未選択</option>
                      <option value="1">承認待ち</option>
                      <option value="2">差し戻し</option>
                      <option value="3">承認済み</option>
                    </b-form-select>
                  </b-col>
                  <b-col cols="3" class="w-100 pt-1 pl-1 pr-0 mt-2 pb-0">
                          <label class="mb-1">営業担当者名</label>
                          <b-form-select
                              id="business_user_id"
                              v-model="inputSearchBusinessUserId"
                          >
                            <option v-for="(businessUser, key) in searchPullDown.businessUser" :value="businessUser.user_id" :key="key" >
                              {{ businessUser.user_name }}
                            </option>
                          </b-form-select>
                        </b-col>
                </b-row>
              </b-collapse>
              <div class="p-0 m-0 d-flex flex-wrap justify-content-between align-items-end">
                <div @click="visible = !visible" class="cursor-pointer fs-14-bold">
                  <div v-if="visible">
                    閉じる <font-awesome-icon icon="chevron-up" />
                  </div>
                  <div v-if="!visible">
                    詳細検索 <font-awesome-icon icon="chevron-down" />
                  </div>
                </div>
                <div>
                  <b-button size="sm" class="with-btn"  variant="outline-secondary" @click="searchItemClear" pill>検索項目をクリア</b-button>
                  <b-button size="sm" class="with-btn ml-3 btn-under-2-char" variant="primary" type="submit" pill>検索</b-button>
                </div>
              </div>
            </b-form>
          </b-form-group>
        </validation-observer>
        </b-card>
        <b-card class="mt-3">
          <b-row class="p-0 m-0">
            <b-col cols="12" class="w-100 p-0">
              <CommonPagination
                  :listTotalRowCountProps="computedListTotalRowCount"
                  :perPageProps="computedPerPage"
                  :currentPageProps="computedCurrentPage"
                  :perPageoptionRestrictionsProps="true"
                  :isShowPageOptions="false"
                  @searchingAgain="pagingSearchingAgain"
                  @changePerPage="onShowRowCountButonClick"
              />
            </b-col>
          </b-row>
          <b-row class="mt-3 p-0 m-0">
            <b-col cols="12" class="p-0 m-0">
              <CommonColumnDragTable
                  ref="selectableTable"
                  v-model="fields"
                  :items="approvalDataList"
                  @sortChange="sortChanged"
                  class="mb-0"
              >
                <template v-slot:title="row">
                  <p
                      class="font-weight-bold m-0"
                      :disabled="row.title.length < 49"
                      v-b-tooltip.hover placement="bottom"
                      :title="row.title"
                  >
                    {{ row.title.length > 48 ? row.title.substring(0, 48) + '...' : row.title }}
                  </p>
                </template>
                <template v-slot:approvalRequestStatus="row">
                  <b-button v-if="row.approvalRequestStatus === 1" class="d-flex align-items-center m-auto" variant="primary" size="sm" @click="modalOpen(row.i)"><font-awesome-icon icon="book" /></b-button>
                  <p v-else class="m-0 text-center" :class="row.approvalRequestStatus === 3 ? ['text-dark', 'font-weight-bold'] : ['text-danger', 'font-weight-normal']">{{ row.approvalRequestStatus === 3 ? '承認' : '差し戻し' }}</p>
                </template>
              </CommonColumnDragTable>
            </b-col>
          </b-row>
        </b-card>
      </main>
      <!-- モーダル -->
      <b-modal centered id="approvalModal" size="smoll" :hide-footer="true" @hide="resetValidFlag" content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close()"/>
        </template>
        <validation-observer ref="validationObserver">
          <div>
            <div><p style="font-size: 1rem;"><span class="mr-2">{{ modalCorporateName }}</span>様の契約内容の承認をお願いします。</p></div>
          </div>
          <div class="mt-4">
            <b-button size="xl" variant="primary" class="mr-5" pill @click="applicableScreen()">該当画面へ</b-button>
          </div>
          <div class="mt-4">
            <p class="m-0">コメント</p>
            <validation-provider name="コメント" :rules="{ required: isCommentVlidFlag, max: 500 }" v-slot="validationContext">
              <b-form-group>
                <b-form-textarea
                  id="textarea"
                  v-model="body"
                  rows="3"
                  max-rows="6"
                  :state="getValidationState(validationContext)"
                  aria-describedby="input-1-live-feedback"
                />
                <b-form-invalid-feedback id="input-1-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <b-button size="xl" variant="danger" class="w-100 m-0 mr-2" pill style="max-width: 100px;" @click="onBtnClick('sendBack')">差し戻し</b-button>
            <b-button size="xl" variant="primary" class="w-100 m-0 ml-2" pill style="max-width: 100px;" @click="onBtnClick('approval')">承認</b-button>
          </div>
        </validation-observer>
      </b-modal>
      <!-- ローディング -->
      <b-modal centered :title="isLoadingTxt" v-model="isModalShow" hide-header hide-footer hide-header-close no-close-on-backdrop no-close-on-esc>
        <CommonLoader :title="isLoadingTxt"/>
      </b-modal>
      <!-- validateチェックアラート -->
      <common-validate-check-alert
        @isValidAlertClose="alertClose"
        :isValidAlertProps="isValidAlert"
        :isValidAlertMessageProps="isValidAlertMessage"
      />
    </b-container>
  </div>
</template>
<script>

// NOTE: ローディングの共通文言を取得
import LoadingTxt from '../utils/loading-text-util'

// NOTE:カラムドラッグテーブルUI
import CommonColumnDragTable from '@/components/common/CommonColumnDragTable'

// NOTE: 共通ページネーションUI
import CommonPagination from '../components/common/CommonPagination'

// NOTE: 共通タイトルUI
import CommonTitle from '../components/common/CommonTitle'

import ToastTextUtil from '../utils/toast-text-util'

import CommonValidateCheckAlert from '../components/common/CommonValidateCheckAlert'
import CommonModalButtonClose from '@/components/common/CommonModalButtonClose.vue'
import CommonLoader from '@/components/common/CommonLoader.vue'

export default {
  name: 'app',
  components: {
    CommonLoader,
    CommonModalButtonClose,
    CommonColumnDragTable,
    CommonPagination,
    CommonTitle,
    CommonValidateCheckAlert
  },
  data () {
    return {
      fields: [
        {
          key: 'approvalRequestStatus',
          label: '承認',
          sortable: true
        },
        {
          key: 'title',
          label: 'タイトル',
          sortable: true
        },
        {
          key: 'requestedTimestamp',
          label: '配信日時',
          sortable: true
        },
        {
          key: 'tasId',
          label: 'TAS ID',
          sortable: true
        },
        {
          key: 'customerId',
          label: '申込番号',
          sortable: true
        },
        {
          key: 'forAnswerCorporateName',
          label: '会社名',
          sortable: true
        },
        {
          key: 'personInChargeName',
          label: '担当者名',
          sortable: true
        },
        {
          key: 'mypageMailAddress',
          label: 'メールアドレス',
          sortable: true
        },
        {
          key: 'telephoneNumber',
          label: '電話番号',
          sortable: false
        },
        {
          key: 'personInChargePhoneNumber',
          label: '携帯電話番号',
          sortable: true
        },
        {
          key: 'customerRegisteredTimestamp',
          label: '申込日時',
          sortable: true
        },
        {
          key: 'serviceStartDate',
          label: 'サービス開始日時',
          sortable: true
        },
        {
          key: 'approvalCategory',
          label: '承認カテゴリ',
          sortable: false
        },
        {
          key: 'businessUserName',
          label: '営業担当者名',
          sortable: false
        }
      ],
      transProps: {
        name: 'flip-list'
      },
      approvalDataList: [],
      listTotalCount: 0,
      currentPage: 1,
      perPage: 20,
      mouseFlag: null,
      contractApprovalRequestId: '',
      customerId: '',
      customerFirstTimeApplicationStatus: null,
      modalCorporateName: '',
      body: '',
      updatedTimestamp: '',
      isLoadingTxt: '',
      isModalShow: false,
      isCommentVlidFlag: true,
      isSaveChack: false,
      isValidAlertMessage: [],
      isValidAlert: false,
      // 検索用プルダウン
      searchPullDown: {
        approvalCategory: [],
        businessUser: [],
        approvalRequestStatus: []
      },
      // 検索
      inputSearchTasId: '',
      inputSearchCustomerId: '',
      inputSearchForAnswerCorporateName: '',
      inputSearchPersonInChargeName: '',
      inputSearchMailAddress: '',
      inputSearchTelephoneNumber: '',
      inputSearchMobileTelephoneNumber: '',
      inputSearchRegisteredTimestampFrom: '',
      inputSearchRegisteredTimestampTo: '',
      inputSearchServiceStartDateFrom: '',
      inputSearchServiceStartDateTo: '',
      inputSearchApprovalCategory: '',
      inputSearchBusinessUserId: '',
      inputSearchApprovalRequestStatus: '',
      sortByKeyName: null,
      sortDescSync: false,
      visible: true
    }
  },
  computed: {
    computedCurrentPage () {
      return this.currentPage
    },
    computedPerPage () {
      return this.perPage
    },
    computedListTotalRowCount () {
      return this.listTotalCount
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    /**
     * テーブルの列ソートが実行された時の処理
     * @param obj
     */
    sortChanged (obj) {
      this.sortByKeyName = obj.sortBy
      this.sortDescSync = obj.sortDesc
      this.currentPage = 1
      this.getList()
      this.$refs.selectableTable.scrollToTop()
    },
    alertClose () {
      this.isValidAlert = false
    },
    getValidationState ({ dirty, validated, valid = null }) {
      this.isSaveChack = dirty || validated ? valid : null
      return dirty || validated ? valid : null
    },
    getList () {
      const GET_ORDERSR_DETAIL_VALID = this.$refs.searchValidationObserver.validate()
      Promise.all([ GET_ORDERSR_DETAIL_VALID ]).then((res) => {
        if (res[0]) {
          const temporaryHolding = this.currentPage
          // プルダウン
          this.createPullDown()
          // 検索条件
          let searchParams = this.getSearchParams()
          let strSearchParams = ''
          if (searchParams) {
            strSearchParams = '?' + Object.entries(searchParams).map((e) => `${e[0]}=${e[1]}`).join('&')
          }
          this.isLoadingTxt = LoadingTxt.getTxt
          this.isModalShow = true
          this.$axios.get(process.env.VUE_APP_BASE_API_URL + '/api/v1/contract/getList' + strSearchParams).then(response => {
            this.approvalDataList = []
            for (let i in response.data.items.contract_approval_request) {
              let tempArray = {}
              tempArray.i = i
              tempArray.contractApprovalRequestId = response.data.items.contract_approval_request[i].contract_approval_request_id
              tempArray.tasId = response.data.items.contract_approval_request[i].tas_id
              tempArray.customerId = response.data.items.contract_approval_request[i].customer_id
              tempArray.customerFirstTimeApplicationStatus = response.data.items.contract_approval_request[i].customer_first_time_application_status
              tempArray.title = response.data.items.contract_approval_request[i].title
              let requestedTimestamp = new Date(response.data.items.contract_approval_request[i].requested_timestamp)
              tempArray.requestedTimestamp = requestedTimestamp.getFullYear() + '/' + (requestedTimestamp.getMonth() + 1) + '/' + requestedTimestamp.getDate() + ' ' + ('00' + requestedTimestamp.getHours()).slice(-2) + ':' + ('00' + requestedTimestamp.getMinutes()).slice(-2)
              tempArray.approvalRequestStatus = response.data.items.contract_approval_request[i].approval_request_status
              tempArray.forAnswerCorporateName = response.data.items.contract_approval_request[i].for_answer_corporate_name
              tempArray.personInChargeName = response.data.items.contract_approval_request[i].person_in_charge_name
              tempArray.mypageMailAddress = response.data.items.contract_approval_request[i].mypage_mail_address
              // ▼ 電話番号 ▼
              tempArray.telephoneNumber = ''
              if (response.data.items.contract_approval_request[i].for_answer_telephone_number_1) {
                tempArray.telephoneNumber = response.data.items.contract_approval_request[i].for_answer_telephone_number_1
              }
              if (response.data.items.contract_approval_request[i].for_answer_telephone_number_2) {
                if (tempArray.telephoneNumber === '') {
                  tempArray.telephoneNumber = response.data.items.contract_approval_request[i].for_answer_telephone_number_2
                } else {
                  tempArray.telephoneNumber = tempArray.telephoneNumber + '/' + response.data.items.contract_approval_request[i].for_answer_telephone_number_2
                }
              }
              if (response.data.items.contract_approval_request[i].for_answer_telephone_number_3) {
                if (tempArray.telephoneNumber === '') {
                  tempArray.telephoneNumber = response.data.items.contract_approval_request[i].for_answer_telephone_number_3
                } else {
                  tempArray.telephoneNumber = tempArray.telephoneNumber + '/' + response.data.items.contract_approval_request[i].for_answer_telephone_number_3
                }
              }
              // ▲ 電話番号 ▲
              tempArray.personInChargePhoneNumber = response.data.items.contract_approval_request[i].person_in_charge_phone_number
              let registeredTimestamp = new Date(response.data.items.contract_approval_request[i].customer_registered_timestamp)
              tempArray.customerRegisteredTimestamp = registeredTimestamp.getFullYear() + '/' + (registeredTimestamp.getMonth() + 1) + '/' + registeredTimestamp.getDate() + ' ' + ('00' + registeredTimestamp.getHours()).slice(-2) + ':' + ('00' + registeredTimestamp.getMinutes()).slice(-2)
              let serviceStartDate = new Date(response.data.items.contract_approval_request[i].service_start_date)
              tempArray.serviceStartDate = serviceStartDate.getFullYear() + '/' + (serviceStartDate.getMonth() + 1) + '/' + serviceStartDate.getDate()
              tempArray.approvalCategory = ''
              if (response.data.items.contract_approval_request[i].approval_request_type === 3) {
                tempArray.approvalCategory = '書類承認'
              } else {
                if (response.data.items.contract_approval_request[i].registered_timestamp < response.data.items.contract_approval_request[i].service_start_date) {
                  tempArray.approvalCategory = '内容承認'
                } else {
                  tempArray.approvalCategory = '変更承認'
                }
              }
              tempArray.businessUserName = response.data.items.contract_approval_request[i].user_name
              tempArray.updatedTimestamp = response.data.items.contract_approval_request[i].updated_timestamp
              this.approvalDataList.push(tempArray)
            }
            this.listTotalCount = response.data.items.total_row_count
            this.currentPage = 1
          }).catch(error => {
            console.log(error)
            this.$bvToast.toast('通信エラー', { title: 'エラー', variant: 'danger' })
            this.isModalShow = false
          }).finally(() => {
            this.isModalShow = false
            this.currentPage = temporaryHolding
          })
        } else {
          this.isValidAlertMessage = []
          const validErrorObj = {}
          validErrorObj['itemName'] = '検索'
          validErrorObj['itemList'] = []
          const validError = this.$refs.searchValidationObserver.errors
          Object.keys(validError).forEach(key => {
            if (validError[key].length !== 0) {
              validErrorObj['itemList'].push(validError[key][0])
            }
          })
          this.isValidAlertMessage.push(validErrorObj)
          this.isValidAlert = true
          return true
        }
      }).catch(error => {
        // NOTE: エラーになることはないと思うが一旦おまじない
        this.$bvToast.toast(
          error.message,
          {
            title: ToastTextUtil.errorTitle,
            variant: 'danger',
            noAutoHide: true,
            toaster: 'b-toaster-top-center'
          }
        )
      })
    },
    createPullDown () {
      // プルダウン
      // NOTE: 読み込み速度改善をしました
      const GET_BUSINESSUSER = this.$axios.get(process.env.VUE_APP_BASE_API_URL + '/api/v1/businessTalk/getBusinessUser')
      Promise.all([ GET_BUSINESSUSER ]).then(response => {
        // 検索条件 商談時営業担当者
        this.searchPullDown.businessUser = []
        const notSelected1 = {
          'user_id': '',
          'user_name': '未選択'
        }
        this.searchPullDown.businessUser.push(notSelected1)
        if (response[0].data.items) {
          for (let i = 0; i < response[0].data.items.length; i++) {
            this.searchPullDown.businessUser.push(response[0].data.items[i])
          }
        }
      }).catch(error => {
        console.log(error)
        this.$bvToast.toast('通信エラー', { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
      }).finally(() => {
        // 一覧データ表示の方が基本的に後に終わるので、ここではモーダル解除しない
        // this.isModalShow = false
      })
    },
    reset () {
      this.approvalDataList = []
      this.listTotalCount = 0
      this.contractApprovalRequestId = ''
      this.customerId = ''
      this.modalCorporateName = ''
      this.body = ''
      this.updatedTimestamp = ''
    },
    // NOTE: 表示件数変更ボタンを押した時の処理
    onShowRowCountButonClick (e) {
      this.perPage = e
      this.currentPage = 1
      this.getList()
      this.$refs.selectableTable.scrollToTop()
    },
    // NOTE: 流れるテキストの処理
    mouseOverAddClass (index) {
      this.mouseFlag = index
    },
    // NOTE: 流れるテキストの処理削除
    mouseLeaveRemoveClass () {
      this.mouseFlag = null
    },
    // NOTE: 承認モーダル
    modalOpen (index) {
      this.contractApprovalRequestId = this.approvalDataList[index].contractApprovalRequestId
      this.customerId = this.approvalDataList[index].customerId
      this.customerFirstTimeApplicationStatus = this.approvalDataList[index].customerFirstTimeApplicationStatus
      this.modalCorporateName = this.approvalDataList[index].forAnswerCorporateName
      this.updatedTimestamp = this.approvalDataList[index].updatedTimestamp
      this.$bvModal.show('approvalModal')
      this.body = ''
    },
    // NOTE: 該当画面
    applicableScreen () {
      let routeData = ''
      console.log(this.customerFirstTimeApplicationStatus)
      if (this.customerFirstTimeApplicationStatus === 150) {
        routeData = this.$router.resolve({ path: '/customer_management/list/' + this.customerId + '/detail' })
      } else {
        routeData = this.$router.resolve({ path: '/customer_entry/list/' + this.customerId + '/detail' })
      }
      // NOTE: 別タブを開いて遷移してしまうと詳細画面の戻るボタンが機能しなくなってしまうための対処
      localStorage.setItem('bsckButtonChange', 'windowClose')
      window.open(routeData.href, '_blank')
    },
    // NOTE: isCommentVlidFlagを条件によって変更
    onBtnClick (e) {
      if (e === 'sendBack') {
        this.isCommentVlidFlag = true
        this.sendBack()
      } else {
        this.isCommentVlidFlag = false
        this.approval()
      }
    },
    // NOTE: 差し戻し
    sendBack () {
      this.isValidAlertMessage = []
      const validCheck = this.$refs.validationObserver.validate()
      validCheck.then((value) => {
        if (this.isSaveChack) {
          this.isLoadingTxt = LoadingTxt.allProcessingTxt
          this.isModalShow = true
          this.$bvModal.hide('approvalModal')
          let params = new URLSearchParams()
          params.append('contract_approval_request_id', this.contractApprovalRequestId)
          params.append('customer_id', this.customerId)
          params.append('approval_request_status', 2) // 差し戻し
          params.append('body', this.body)
          params.append('updated_timestamp', this.updatedTimestamp)
          params.append('for_answer_corporate_name', this.modalCorporateName)
          params.append('approved_user_id', localStorage.user_id)
          this.$axios.post(process.env.VUE_APP_BASE_API_URL + '/api/v1/contract/update', params).then(response => {
            if (response.data.result_code === 2000) {
              this.reset()
              this.getList()
              this.getSideMenuNotification(localStorage.user_id)
            } else {
              this.$bvToast.toast(response.data.result_message, { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
              this.isModalShow = false
              this.isCommentVlidFlag = false
            }
          }).catch(error => {
            console.log(error.response)
            console.log(error.response.status)
            if (error.response.status === 400) {
              // alert('処理の途中でエラーが発生しました\n（' + error.response.data.result_message + '）')
              this.$bvToast.toast(error.response.data.result_message, { title: '処理の途中でエラーが発生しました', variant: 'danger' })
            } else {
              // alert('処理の途中でエラーが発生しました')
              this.$bvToast.toast('処理の途中でエラーが発生しました', { title: 'エラー', variant: 'danger' })
              this.isModalShow = false
              this.isCommentVlidFlag = false
            }
          }).finally(() => {
          })
        } else {
          // NOTE: setTimeoutでエラーの取得を遅らせる
          setTimeout(() => {
            const validAlertObj = {}
            const validItem = this.$refs.validationObserver.errors
            validAlertObj['itemList'] = []
            Object.keys(validItem).forEach(key => {
              if (validItem[key].length !== 0) {
                validAlertObj['itemList'].push(validItem[key][0])
              }
            })
            this.isValidAlertMessage.push(validAlertObj)
            this.isValidAlert = true
          }, 100)
        }
      })
    },
    // NOTE: 承認
    approval () {
      this.isValidAlertMessage = []
      const validCheck = this.$refs.validationObserver.validate()
      validCheck.then((value) => {
        if (this.body.length <= 500) {
          this.isLoadingTxt = LoadingTxt.allProcessingTxt
          this.isModalShow = true
          this.$bvModal.hide('approvalModal')
          let params = new URLSearchParams()
          params.append('contract_approval_request_id', this.contractApprovalRequestId)
          params.append('customer_id', this.customerId)
          params.append('approval_request_status', 3) // 承認
          params.append('body', this.body)
          params.append('updated_timestamp', this.updatedTimestamp)
          params.append('for_answer_corporate_name', this.modalCorporateName)
          params.append('approved_user_id', localStorage.user_id)
          this.$axios.post(process.env.VUE_APP_BASE_API_URL + '/api/v1/contract/update', params).then(response => {
            if (response.data.result_code === 2000) {
              this.reset()
              this.getList()
              this.getSideMenuNotification(localStorage.user_id)
            } else {
              this.$bvToast.toast(response.data.result_message, { title: ToastTextUtil.errorTitle, variant: 'danger', noAutoHide: true, toaster: 'b-toaster-top-center' })
              this.isModalShow = false
              this.isCommentVlidFlag = false
            }
          }).catch(error => {
            console.log(error.response)
            console.log(error.response.status)
            if (error.response.status === 400) {
              // alert('処理の途中でエラーが発生しました\n（' + error.response.data.result_message + '）')
              this.$bvToast.toast(error.response.data.result_message, { title: '処理の途中でエラーが発生しました', variant: 'danger' })
            } else {
              // alert('処理の途中でエラーが発生しました')
              this.$bvToast.toast('処理の途中でエラーが発生しました', { title: 'エラー', variant: 'danger' })
            }
            this.isModalShow = false
            this.isCommentVlidFlag = false
          }).finally(() => {
          })
        } else {
          // NOTE: setTimeoutでエラーの取得を遅らせる
          setTimeout(() => {
            const validAlertObj = {}
            const validItem = this.$refs.validationObserver.errors
            validAlertObj['itemList'] = []
            Object.keys(validItem).forEach(key => {
              if (validItem[key].length !== 0) {
                validAlertObj['itemList'].push(validItem[key][0])
              }
            })
            this.isValidAlertMessage.push(validAlertObj)
            this.isValidAlert = true
          }, 100)
        }
      })
    },
    // NOTE: isCommentVlidFlagを初期化
    resetValidFlag () {
      this.isCommentVlidFlag = false
    },
    // NOTE: ページング再検索
    pagingSearchingAgain (e) {
      this.currentPage = e
      this.getList()
      this.$refs.selectableTable.scrollToTop()
    },
    /***
     * 検索ボタンを押した時の処理 条件(ページ番号、表示件数、ソート、スクロール位置)をすべてリセット
     */
    onSearchButtonClick () {
      this.currentPage = 1
      this.perPage = 20
      this.$refs.selectableTable.clearSort()
      this.sortByKeyName = null
      this.sortDescSync = false
      this.reset()
      this.getList()
    },
    getSearchParams () {
      let searchParams = {}
      searchParams.current_page = this.currentPage
      searchParams.per_page = this.perPage
      searchParams.input_search_tas_id = this.inputSearchTasId
      searchParams.input_search_customer_id = this.inputSearchCustomerId
      searchParams.input_search_for_answer_corporate_name = this.inputSearchForAnswerCorporateName
      searchParams.input_search_person_in_charge_name = this.inputSearchPersonInChargeName
      searchParams.input_search_mail_address = this.inputSearchMailAddress
      searchParams.input_search_telephone_number = this.inputSearchTelephoneNumber
      searchParams.input_search_mobile_telephone_number = this.inputSearchMobileTelephoneNumber
      searchParams.input_search_registered_timestamp_from = this.inputSearchRegisteredTimestampFrom
      searchParams.input_search_registered_timestamp_to = this.inputSearchRegisteredTimestampTo
      searchParams.input_search_service_start_date_from = this.inputSearchServiceStartDateFrom
      searchParams.input_search_service_start_date_to = this.inputSearchServiceStartDateTo
      searchParams.input_search_approval_category = this.inputSearchApprovalCategory
      searchParams.input_search_business_user_id = this.inputSearchBusinessUserId
      searchParams.input_search_approval_request_status = this.inputSearchApprovalRequestStatus
      searchParams.sort_by_key_name = this.sortByKeyName
      searchParams.sort_desc_sync = this.sortDescSync
      return searchParams
    },
    // NOTE: 検索項目のクリア
    searchItemClear () {
      this.inputSearchTasId = ''
      this.inputSearchCustomerId = ''
      this.inputSearchForAnswerCorporateName = ''
      this.inputSearchPersonInChargeName = ''
      this.inputSearchMailAddress = ''
      this.inputSearchTelephoneNumber = ''
      this.inputSearchMobileTelephoneNumber = ''
      this.inputSearchApprovalCategory = ''
      this.inputSearchBusinessUserId = ''
      this.inputSearchApprovalRequestStatus = ''
      this.inputSearchRegisteredTimestampClear()
      this.inputSearchServiceStartDateClear()
    },
    inputSearchRegisteredTimestampClear () {
      this.inputSearchRegisteredTimestampFrom = ''
      this.inputSearchRegisteredTimestampTo = ''
      this.$refs['input-search-registered-timestamp-from'].$el.value = ''
      this.$refs['input-search-registered-timestamp-to'].$el.value = ''
      this.$refs.inputSearchRegisteredTimestampFrom.reset()
      this.$refs.inputSearchRegisteredTimestampTo.reset()
    },
    inputSearchServiceStartDateClear () {
      this.inputSearchServiceStartDateFrom = ''
      this.inputSearchServiceStartDateTo = ''
      this.$refs['input-search-service-start-date-from'].$el.value = ''
      this.$refs['input-search-service-start-date-to'].$el.value = ''
      this.$refs.inputSearchServiceStartDateFrom.reset()
      this.$refs.inputSearchServiceStartDateTo.reset()
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-select{
  padding: 4px;
}
</style>
